const projects = [
  {
    key: 'Unilodgers',
    name: 'Unilodgers',
    tech: ['Ruby on Rails', 'React.js', 'MySQL', 'Redis', 'Elastic Search'],
    oneliner: 'A student housing platform',
    description: 'Unilodgers is a student accommodation marketplace, providing accommodations mainly in US, UK, AUS & Ireland',
    link: 'https://unilodgers.com',
    image: ['https://i.imgur.com/0cSicXv.png', 'https://i.imgur.com/9E77kgi.png', 'https://i.imgur.com/8wp8JWV.png', 'https://i.imgur.com/k0w1ZBX.png', 'https://i.imgur.com/qb1aiOE.png']
  },
  {
    key: 'Birthday Card',
    name: 'Birthday Card',
    tech: ['Vanilla Js'],
    oneliner: 'A birthday greeting card',
    description: "Since posting birthday card is riskier during this pandemic time, here's a digital birthday envelope to give it to someone",
    link: 'https://happy-swirles-befbd4.netlify.app/',
    image: ['https://i.imgur.com/cbm30im.png', 'https://i.imgur.com/QJNE6rV.png']
  },
  {
    key: 'Uni Chat',
    name: 'Uni Chat',
    tech: ['React.js', 'Phoenix', 'Elixir', 'MySQL', 'Twilio'],
    oneliner: 'A whatsapp client built using twilio sandbox',
    description: 'A whatsapp client that can be used by multiple people simultaneously.',
    link: 'https://chat.unilodgers.com',
    image: ['https://i.imgur.com/53PGklT.png', 'https://i.imgur.com/qy5AMnd.png']
  },
  {
    key: 'Portfolio',
    name: 'Portfolio',
    tech: ['React.js'],
    oneliner: 'A portfolio website template',
    description: 'A portfolio website template, designed on React that you can use to create you own portfolio just by changing the data json',
    link: 'https://iamgrawal.netlify.app/',
    image: ['https://i.imgur.com/y91Th3f.png', 'https://i.imgur.com/SNIAw0E.png', 'https://i.imgur.com/ikMRZ0Y.png']
  },
  {
    key: 'Birthday Card 2',
    name: 'Birthday Card 2',
    tech: ['Vanilla Js'],
    oneliner: 'A birthday greeting card',
    description: "Since posting birthday card is riskier during this pandemic time, here's a digital birthday envelope to give it to someone",
    link: 'https://cake-envelope-d8610c.netlify.app/',
    image: ['https://i.imgur.com/avPvBv9.png', 'https://i.imgur.com/jp3HXJZ.png']
  },
  {
    key: 'Music Maker',
    name: 'Music Maker',
    tech: ['Vanilla Js'],
    oneliner: 'A website to generate music from notes',
    description: 'A website to generate music from notes. Comes with a classic ball spinning around animation when you click on the notes',
    link: 'https://kutt.it/music-maker',
    image: ['https://i.imgur.com/HcYEXhN.png', 'https://i.imgur.com/R2jcRti.png', 'https://i.imgur.com/cFbnhcW.png', 'https://i.imgur.com/qbOypFy.png']
  },
  {
    key: 'Regression Curve',
    name: 'Regression Curve',
    tech: ['TensorFlow.js', 'p5.js'],
    oneliner: 'A simple website to demonstrate regression curves',
    description: 'A simple website to demonstrate regression curves for various parameters',
    link: 'https://codesandbox.io/s/github/iamgrawal/regression-curve',
    image: ['https://i.imgur.com/omAdXXv.png']
  },
  {
    key: 'AI Playground',
    name: 'AI Playground',
    tech: ['React.js', 'Firebase'],
    oneliner:
      'An online playground where you can create and publish AI apps, like Chatbots, Text Analyser, Image Analyser, etc.',
    description:
      'An online playground where you can create and publish AI apps, like Chatbots, Text Analyser, Image Analyser, etc. It is built on React.js and Firebase.',
    link: 'https://ai.campk12.com',
    image: ['https://i.imgur.com/IcsML7a.png']
  },
  {
    key: 'MIDI Mixer',
    name: 'MIDI Mixer',
    tech: ['React.js', 'Firebase'],
    oneliner:
      'An online collaborarive platform in which you can generate sounds of various instruments.',
    description:
      'An online collaborarive platform in which you can generate sounds of various instruments while being online with friends in the same room. This platform is built using React and Socket.io, also hosted on firebase',
    link: 'https://github.com/iamgrawal/react-masterclass',
    image: ['https://i.imgur.com/Uik4bBi.png']
  },
  {
    key: 'GenB',
    name: 'Generation Blockchain',
    tech: ['Angularjs', 'Node.js', 'Firebase', 'MongoDb'],
    oneliner:
      'A blockchain forum where you can ask questions and as well as answer questions.',
    description:
      'A blockchain forum where you can ask questions and as well as answer questions. Designed for the purpose of Generation Blockchain Workshop(a 3-day blockchain workshop held at IIT Delhi). This platform is built using angular.js, express.js, node.js, MongoDb, firebase and hosted on heroku.',
    link: 'https://generationblockchain.io',
    image: [
      'https://i.imgur.com/STtGKEf.png',
      'https://i.imgur.com/YLJNGY1.png',
      'https://i.imgur.com/ZvtjxOL.png',
      'https://i.imgur.com/age2pAr.png'
    ]
  },
  {
    key: 'Buttons',
    name: 'Social Media Buttons',
    tech: ['HTML', 'CSS'],
    oneliner: 'A social media icons animation repository.',
    description: 'A social media icons animation repository.',
    link: 'https://iamgrawal.github.io/social-media-buttons',
    image: [
      'https://user-images.githubusercontent.com/14204344/47875627-0d299380-de3d-11e8-9480-322437fb8e87.gif'
    ]
  },
  {
    key: 'NG5',
    name: 'Bucket List',
    tech: ['Angular', 'Node.js'],
    oneliner: 'A bucket list angular app',
    description:
      'An angular app in which you can create your bucket lists. This app is build on angular version 5. It is used to represent routing and two-way data-binding concepts in angular.',
    link: 'https://iamgrawal.github.io/ng5/',
    image: ['https://i.imgur.com/TH4LEvk.png']
  },
  {
    key: 'Tinder',
    name: 'Tinder Swipe Cards',
    tech: ['React.js', 'Node.js'],
    oneliner: 'A dummy project to imitate tinder swipe cards animation feature',
    description:
      'A dummy project to imitate tinder swipe cards animation feature. This app is build on React. Used styled-components for CSS-in-JS, also known JSS ',
    link: 'https://iamgrawal.github.io/tinder-swipe-cards',
    image: ['https://i.imgur.com/5VoeXMT.jpg']
  }
];

export default projects;
